import { Result } from 'entities/result'
import { ReactNode } from 'react'
import { ResultInfoV2, ResultV2ViewModel, RiskData, RiskScore } from './result_v2_view_model'
import { Symptom } from 'components/send_history/result_v2'
import { Sample } from 'entities/sample'

export type StomachRiskScore = RiskScore & {
    stomach_family_history: number
    helicobacter: number
    chronic_gastritis: number
    gastric_ulcer: number
    smoking: number
    eating_habits_of_salted_food: number
}
type StomachRiskRatio = StomachRiskScore

type StomachResultInfoV2 = ResultInfoV2 & {
    risk_score: StomachRiskScore
    risk_ratio: StomachRiskRatio
    risk_data: RiskData<StomachRiskScore>
}

export class StomachResultV2ViewModel extends ResultV2ViewModel {
    constructor(result: Result, sample: Sample) {
        super(result, '胃がん', '0.1%程度', '1%程度', sample)
    }
    public info(): StomachResultInfoV2 {
        return super.info() as StomachResultInfoV2
    }

    private hasHelicobacter = (): boolean => {
        return this.background.medicalHistories?.some((mh) => mh.disease === 'helicobacter') ?? false
    }

    private hasChronicGastritis = (): boolean => {
        return this.background.medicalHistories?.some((mh) => mh.disease === 'chronic_gastritis') ?? false
    }

    private hasGastricUlcer = (): boolean => {
        return this.background.medicalHistories?.some((mh) => mh.disease === 'gastric_ulcer') ?? false
    }

    public stomach_family_history = () => {
        if (this.background.familyHistories?.some((fh) => fh.cancer === 'stomach' && (fh.withinFirstDegreeRelative ?? 0) > 0)) {
            return '当てはまる'
        } else {
            return '該当なし'
        }
    }

    public helicobacter = () => {
        return this.hasHelicobacter() ? 'あり' : 'なし'
    }

    public chronic_gastritis = () => {
        return this.hasChronicGastritis() ? 'あり' : 'なし'
    }

    public gastric_ulcer = () => {
        return this.hasGastricUlcer() ? 'あり' : 'なし'
    }

    public smoking = () => {
        if (this.background.smoking === 'now') {
            return '吸う'
        } else if (this.background.smoking === 'ever') {
            return 'やめた'
        } else {
            return '吸わない'
        }
    }

    public eating_habits_of_salted_food = () => {
        if (this.background.eatingHabitsOfSaltedFood === 'unusual') {
            return '週2日以下'
        } else if (this.background.eatingHabitsOfSaltedFood == 'sometimes') {
            return '週3〜5日'
        } else {
            return '週6日以上'
        }
    }

    public getMiddleTextPosition(): { bottom: number; left: number } {
        return { bottom: 135, left: 125 }
    }
    public getHighTextPosition(): { top: number; right: number } {
        return { top: 2, right: 5 }
    }

    public symptomsView(symptoms: Symptom[]): ReactNode {
        return super.symptomsView(symptoms, 15)
    }
}
